<fmnts-pseudo-checkbox
  [disabled]="disabled"
  [readonly]="readonly"
  [state]="checkboxState()"
/>
<span class="fmnts-checkbox__label">
  <ng-content />
</span>
